import { useContext } from 'react';

import EADialog from 'components/common/EADialog';
import useStyles from 'style/js-style/components/thirdparties/ecovadis/EcovadisStyle';

import { Context } from 'states/Store';

import EcovadisFoundSupplier from './EcovadisFoundSupplier';
import { getEcovadisThirdpartyIntegrationID } from 'services/common/EcovadisUtils';

function EcovadisFoundSupplierDialog({
  isOpen,
  onClose,
  supplier,
  dialogTitle = '',
  onValidate = () => {},
}) {
  const { classes } = useStyles();
  const [state] = useContext(Context);

  const getDialogTitle = () => {
    return (
      <>
        <span>{dialogTitle} </span>
        <span className={classes.thirdpartyName}>{state.thirdparty?.name}</span>
      </>
    );
  };

  return (
    <EADialog
      isOpen={isOpen}
      hasActions={false}
      maxWidth="md"
      fullWidth
      title={getDialogTitle()}
    >
      <div className={classes.root}>
        <EcovadisFoundSupplier
          supplier={supplier}
          messageType="update"
          integrationId={getEcovadisThirdpartyIntegrationID(state.thirdparty.thirdpartyId)}
          shouldTrigger={false}
          onCancel={() => {
            onClose();
          }}
          onValidate={() => onValidate()}
        />
      </div>
    </EADialog>
  );
}

export default EcovadisFoundSupplierDialog;
